export default "__VITE_ASSET__Cn$eve5e__"